'use strict';

var _ = require('lodash');
var StrategyClosureActionFactory = function StrategyClosureActionFactory() {
  function StrategyClosureAction(fareBasisCode, loadFactor, daysToDeparture) {
    this.fareBasisCode = fareBasisCode;
    this.loadFactor = loadFactor;
    this.daysToDeparture = daysToDeparture;
  }
  StrategyClosureAction.prototype.isEmpty = function () {
    return (_.isNil(this.loadFactor) || this.loadFactor === '') && (_.isNil(this.daysToDeparture) || this.daysToDeparture === '');
  };
  StrategyClosureAction.prototype.createCopy = function () {
    return new StrategyClosureAction(this.fareBasisCode, this.loadFactor, this.daysToDeparture);
  };
  return StrategyClosureAction;
};
StrategyClosureActionFactory.$inject = [];
module.exports = StrategyClosureActionFactory;